module App {
    export class Variables {
        static websiteId: number
        static currentPageId: number
        static license: string
        static configuratorType: string
        static thankyoutxt: string
        static noDesiredProducText: string
        static websiteColor: string
        static brandName: string
        static privacyStatement: string
        static websiteUrl: string
        static allowColorChange: boolean
        static firstName: string
        static middleName: string
        static lastName: string
        static phone: string
        static discountCode: string
        static mileage: string
        static gender: string
        static email: string
        static telephone: string
        static workcode: string
        static title: string
        static recurringCustomer: boolean
        static mileageNotRequired: boolean
        static carBrands: string[]
        static fuelTypes: string[]
        static allowLogin: boolean
        static hideActionCode: boolean
        static isRdwAvailable: boolean
        static rdwUnavailableText: string
        static utmParams: App.Interfaces.IUtmParam[]
        static currentSettelmentReplacementVehicleText: App.Interfaces.IReplacementVehicleText[]
        static globalReplacementVehicleText: App.Interfaces.IReplacementVehicleText[]
        static remark: string
    }

    export enum datalayerPageEvents {
        stap1 = 'stap1_voertuiggegevens',
        stap2 = 'stap2_werkzaamheden',
        stap3 = 'stap3_locatie_tijd',
        stap4 = 'stap4_uw_gegevens',
        stap5 = 'stap5_afspraak_bevestigd'
    }
}